export default "__VITE_ASSET__qeYVnjOK__"